import { render } from "./ButtonComponent.vue?vue&type=template&id=fc9d6a74&scoped=true"
import script from "./ButtonComponent.vue?vue&type=script&lang=js"
export * from "./ButtonComponent.vue?vue&type=script&lang=js"

import "./ButtonComponent.vue?vue&type=style&index=0&id=fc9d6a74&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc9d6a74"]])

export default __exports__